<template>
  <tea-main @back="goBack">
    <template slot="nav">
      <div class="stuLicenseListNav">
        <p>执照列表</p>
      </div>
    </template>
    <template slot="main">
      <div class="stuLicenseListMain">
        <yioks-loading v-show="isLoading"></yioks-loading>
        <div class="searchWrap">
          <div class="search">
            <div class="leisureBtn">
              <select v-model="search.license_type" @change="changeQuery">
                <option value="">全部类型</option>
                <option
                  v-for="(item, index) in licenseTypeList"
                  :key="index"
                  :value="item.value"
                >
                  {{ item.key }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <template v-if="!isLoading">
          <template v-if="showList">
            <div class="table">
              <div class="thead">
                <div class="tr">
                  <div class="th index"><strong>序号</strong></div>
                  <div class="th level"><strong>级别</strong></div>
                  <div class="th type"><strong>执照类型</strong></div>
                  <div class="th license_number"><strong>执照编号</strong></div>
                  <div class="th license_end"><strong>执照到期时间</strong></div>
                  <div class="th status"><strong>状态</strong></div>
                  <div class="th opt"><strong>查看</strong></div>
                </div>
              </div>
              <div class="scrollArea" v-if="showList">
                <vue-scroll :ops="ops" ref="vs">
                  <div class="tbodyWrap">
                    <div class="tbody">
                      <div
                        class="tr"
                        v-for="(item, index) in licenseList"
                        :key="index"
                      >
                        <div class="td index">
                          <p >{{ index + 1 }}</p>
                        </div>
                        <div class="td level">
                          <p :title="item.license_level | level">{{ item.license_level | level }}</p>
                        </div>
                        <div class="td type">
                          <p>{{ item.license_type | licenseTypeFilter }}</p>
                        </div>
                        <div class="td license_number">
                          <p>{{ coachLicenseNumber || "--" }}</p>
                        </div>
                        <div class="td license_end">
                          <p>{{ item.license_end || "--" }}</p>
                        </div>
                        <div class="td status">
                          <p v-if="item.is_generate">已生成</p>
                          <p v-else>待生成</p>
                        </div>
                        <div class="td opt">
                          <template v-if="item.is_generate">
                            <span class="look"
                              ><a :href="item.license_address" target="_blank">查看电子执照</a></span
                            >
                          </template>
                          <template v-else>
                            <p :title="item.get_the_date" style="color:white">{{item.get_the_date}}</p>
                          </template>
                        </div>
                      </div>
                    </div>
                  </div>
                </vue-scroll>
              </div>
            </div>
          </template>
          <yioks-empty v-show="showEmpty"></yioks-empty>
        </template>
        <template v-if="showLicenseAddress">
          <license-address
            @hideDialog="hideDialog"
            :showDialog.sync="showLicenseAddress"
            :personInfo="personInfo"
            :orgInfo="orgInfo"
            :disabled="disabled"
            :wait_id="wait_id"
          ></license-address>
        </template>
      </div>
    </template>
  </tea-main>
</template>

<script>
import { coach_qualification_list } from "@/api/system_manager/api";
import ops from "@/assets/js/vuescrollOption";
import { LevelFilters } from "@/assets/js/status";
import { user_license_list } from "@/api/common/api";
import { licenseTypeFilter } from "@/assets/js/yioksFilters";
import { licenseTypeList } from "@/assets/js/select";

export default {
  name: "Teacher",
  data() {
    return {
      licenseTypeList,
      ops: ops(),
      licenseList: [],
      wait_id: "",
      personInfo: {},
      coachLicenseNumber: "",
      disabled: false,
      showLicenseAddress: false,
      orgInfo: {},
      statusList: [
        {
          name: "已确认",
          type: "audit",
        },
        {
          name: "未确认",
          type: "pass",
        },
      ],
      isLoading: true,
      showList: false,
      showEmpty: false,
      list: [],
      search: {
        license_type: "",
      },
    };
  },
  components: {
    "tea-main": () => import("@/components/LayOut/Common/up-down"),
    "yioks-empty": () => import("@/components/Tips/Empty"),
    "v-icon": () => import("vue-awesome/components/Icon"),
    "yioks-loading": () => import("@/components/Loading/Loading"),
    "license-address": () => import("@/components/GetLicense/getLicense"),
  },
  created() {
    // this.request();
    this.setQuery();
    // this.getLicenseList();
    this.changeQuery();
  },
  filters: {
    licenseTypeFilter,
    status(status) {
      if (!status) return "未填写";
      switch (status) {
        case "mail":
          status = "邮寄（到付）";
          break;
        case "invite":
          status = "自取";
          break;
      }
      return status;
    },
    level(val) {
      if (!val) return "--";
      return LevelFilters(val);
    },
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    setQuery() {
        const { license_type } = this.$route;
        license_type && (this.$set(this.search, 'license_type', license_type))
    },
    changeQuery() {
        this.$router.replace({
            path: '',
            query: {
                ...this.search,
            }
        })
        this.getLicenseList();
    },
    getLicenseList() {
      this.isLoading = true;
      const { license_type } = this.$route.query;
      const params = {
        license_type
      }
      user_license_list(params)
        .then(({ data: { status, result, msg } }) => {
          if (Number(status) === 0) {
            this.licenseList = result.list;
            this.coachLicenseNumber = result.coachLicenseNumber;
            this.showList = result.list.length > 0;
            this.showEmpty = !this.showList;
          } else {
            this.$message.error(msg);
          }
          this.isLoading = false;
        })
        .catch((err) => {});
    },
    editAddress(item) {
      this.wait_id = item.wait_id;
      this.disabled = false;
      this.orgInfo = {
        orgName: item.org_abbreviation,
        // orgAddress:item.org_address,
        orgUserName: item.org_user_name,
        orgPhone: item.org_tel_number,
        get_the_date: item.get_the_date,
        license_distribute_way: item.license_distribute_way,
      };
      this.personInfo = {
        consignee: item.consignee,
        city_name: item.city_name,
        postcode: item.postcode,
        city_id: item.city_id ? String(item.city_id) : "",
        consignee_number: item.consignee_number,
        county_id: item.county_id ? String(item.county_id) : "",
        county_name: item.county_name,
        get_the_way: item.get_the_way,
        province_name: item.province_name,
        province_id: item.province_id ? String(item.province_id) : "",
        detailed_address: item.detailed_address,
      };
      this.showLicenseAddress = true;
    },
    lookAddress(item) {
      this.wait_id = item.wait_id;
      this.disabled = true;
      this.orgInfo = {
        orgName: item.org_abbreviation,
        // orgAddress:item.org_address,
        orgUserName: item.org_user_name,
        orgPhone: item.org_tel_number,
        get_the_date: item.get_the_date,
        license_distribute_way: item.get_the_way,
      };
      this.personInfo = {
        consignee: item.consignee,
        city_name: item.city_name,
        postcode: item.postcode,
        city_id: item.city_id ? String(item.city_id) : "",
        consignee_number: item.consignee_number,
        county_id: item.county_id ? String(item.county_id) : "",
        county_name: item.county_name,
        get_the_way: item.get_the_way,
        province_name: item.province_name,
        province_id: item.province_id ? String(item.province_id) : "",
        detailed_address: item.detailed_address,
      };
      this.showLicenseAddress = true;
    },
    hideDialog(bool) {
      if (bool) {
        this.$message.success("信息保存成功!");
        this.showLicenseAddress = false;
        this.getLicenseList();
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
@import '~@/assets/css/mixin'
@import '~@/assets/css/nav_filter'
.stuLicenseListNav, .stuLicenseListMain
  flex 1 1 auto
  height 100%
.stuLicenseListNav
  display flex
  justify-content space-between
  align-items center
  padding 0 12px 0 0
  font-size $font_size_big
  .main_wrap
    display flex
    flex 1
    justify-content space-between
    align-items center
    .left, .right
      display flex
      align-items center
      .btn
        padding 5px 15px
        cursor pointer
        &.active
          background-color $color_suc
        &+.btn
          margin-left 10px
.stuLicenseListMain
  width 100%
  padding 25px 0 0
  background-color $block_bg_color_base
  .table
    width 100%
    margin 30px 0 0
    .thead, .tbody
      border 1px solid $color_white
    .thead
      margin 0 40px
      .tr
        height 45px
        display flex
    .scrollArea
      height 490px
    .tbodyWrap
      display block
      // padding: 0 40px;
    .tbody
      display block
      margin-left auto
      margin-right auto
      width 810px
      max-width 810px
      border-top none
      border-bottom none
      .tr
        height 49px
        display flex
        border-bottom 1px solid $color_white
    .th, .td
      height 100%
      flex 1 1 auto
      display flex
      justify-content center
      align-items center
      font-size 16px
      border-right 1px solid $color_white
    .th:last-child, .td:last-child
      border-right none
    .td:last-child
      color $color_suc
      user-select none
    
    .td
      p
        over_hide()
      .showRecord
        cursor pointer
        
    .license_number
      width 23%
    .license_end
      width 12%
    .status
      width 7%
    .index
      width 6%
    .level
      width 10%
    .type
      width 13%
    .opt
      width 22%
      .look, .edit
        cursor pointer
        color $color_suc
</style>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
@import '~@/assets/css/mixin'
@import '~@/assets/css/nav_filter'
.searchWrap
  display flex
  justify-content space-between
  align-items center
  height 40px
  margin 0 40px
  .search
    width 100%
    height 100%
    display flex
    justify-content space-between
    align-items center
    .wrap
      height 100%
      display flex
      position relative
      input
        // width: 220px;
        width 165px
        height 100%
        padding 0 20px
        font-size $font_size_medium
        color $color_black
        outline none
      .close
        position absolute
        right 95px
        top 10px
        color $color_info
        cursor pointer
      .searchBtn
        width 90px
        height 100%
        display flex
        justify-content center
        align-items center
        font-size 20px
        background-color $color_suc
        cursor pointer
    .leisureBtn
      position relative
      height 100%
      display flex
      select
        width 120px
        // height: 100%;
        padding 0 15px
        font-size $font_size_medium
        color $color_black
        cursor pointer
        outline none
        &+select
          margin-left 15px
    .date_picker
      .el-date-editor
        .el-input__inner
          border-radius 0
</style>

<style lang="stylus" >
.stuLicenseListMain
  .el-date-editor .el-range-separator
    padding 0
</style>
